/*
Credits: JedWatson
License: https://github.com/JedWatson/exenv/blob/master/LICENSE
Repository: https://github.com/JedWatson/exenv/blob/master/index.js
*/

const canUseDOM = () => {
	// eslint-disable-next-line @typescript-eslint/unbound-method
	return Boolean(typeof window !== 'undefined' && window.document.createElement);
};

export default canUseDOM;
